/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import prefabFactory from '@airglow/prefab';

const prefabs = prefabFactory({
  pluginEndpoint: { type: 'value' },
  railOpen: { type: 'toggle', defaultValue: true },
  selectedLayout: { type: 'value', defaultValue: 'single' },
  sendNavigateTo: { type: 'toggle', defaultValue: true },
  sessionNotFound: { type: 'toggle', defaultValue: false },
  showConfigure: { type: 'toggle' },
  showDetails: { type: 'toggle' },
  validationEndpoint: { type: 'value' },
  watchShellSettingsChanges: { type: 'toggle' }
});

export const {
  pluginEndpoint,
  railOpen,
  selectedLayout,
  sendNavigateTo,
  sessionNotFound,
  showConfigure,
  showDetails,
  validationEndpoint,
  watchShellSettingsChanges
} = prefabs;

export default prefabs;
